module.exports = new __parcel__URL__("gran-turismo.6f22df6e.jpg").toString();